import { apiClient } from "@/api/api-client.ts";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { CaseActivity } from "../../types/activities";
import type { CaseEvidence, CaseTestimonialEvidenceSchema } from "../../types/evidence";

const caseEvidenceService = {
	...createBaseService<CaseEvidence>("/case-evidence"),

	listByCaseId: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>(`/case/${id}/evidence`, { params });
		return response.data;
	},

	listAllByCaseId: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseEvidence[]; meta: Pagination }>(`/case/${id}/evidence-list`, { params });
		return response.data;
	},

	createById: async (data: T) => {
		const response = await apiClient.post<{ data: T }>(`/case/${data.case_id}/evidence`, data);
		return response.data.data;
	},

	deleteById: async (caseId: string, id: string) => {
		await apiClient.delete(`/case/${caseId}/evidence/${id}`);
	},

	upsertById: async (data: T) => {
		// const id = data.id;

		// if (id) {
		// 	const response = await apiClient.post<{ data: T }>(
		// 		`/case/${data.case_id}/evidence/${id}`,
		// 		data,
		// 		{
		// 			headers: {
		// 				"Content-Type": "multipart/form-data",
		// 			},
		// 		},
		// 	);
		// 	return response.data.data;
		// }

		const response = await apiClient.post<{ data: T }>(`/case/${data.case_id}/evidence`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});

		return response.data.data;
	},
	deleteMedia: async (evidenceId: string | undefined, mediaId: string | undefined) => {
		await apiClient.delete(`/case/${evidenceId}/media/${mediaId}`);
	},

	upsert: async (data: CaseEvidence) => {
		const id = data?.id;
		if (id) {
			const response = await apiClient.post<{
				data: CaseEvidence;
			}>(`/case/${data.case_id}/evidence/${id}`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			return response.data.data;
		}

		const response = await apiClient.post<{
			data: CaseEvidence;
		}>(`/case/${data.case_id}/evidence`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},

	addSubmarking: async (data: CaseEvidence) => {
		const response = await apiClient.post<{
			data: CaseEvidence;
		}>(`/case/${data.case_id}/evidence/add-submarking`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},

	saveDrawing: async (evidenceId: string, payload: any) => {
		const response = await apiClient.post<{
			payload: any;
		}>("evidence-drawing", {
			evidence_id: evidenceId,
			payload: payload,
		});
		return response.data;
	},

	fetchEvidenceDrawings: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: any[]; meta: Pagination }>(`/case/${id}/evidence-shape`, { params });
		return response.data;
	},

	addMultipleSubmarking: async (data: CaseEvidence[]) => {
		const response = await apiClient.post<{
			data: CaseEvidence;
		}>(`/case/${data[0].case_id}/evidence/add-multiple-submarking`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},

	upsertTestimony: async (data: CaseTestimonialEvidenceSchema) => {
		const id = data?.id;
		if (id) {
			const response = await apiClient.post<{
				data: CaseTestimonialEvidenceSchema;
			}>(`/case/${data.case_id}/evidence/${id}`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			return response.data.data;
		}

		const response = await apiClient.post<{
			data: CaseTestimonialEvidenceSchema;
		}>(`/case/${data.case_id}/evidence`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data.data;
	},
	downloadListByType: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/download-evidence-by-type", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	downloadListByCaseId: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/download-evidence-by-case-id", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	downloadTestimonialEvidenceList: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/download-testimonial-evidence-by-party", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	downloadAllTestimonialEvidenceByCaseId: async (params = {}): Promise<Blob> => {
		const response = await apiClient.post("/download-testimonial-evidence-by-case-id", params, {
			responseType: "blob",
		});

		return new Blob([response.data], { type: "application/pdf" });
	},
	listTsnEvidence: async (id?: string, params = {}) => {
		const response = await apiClient.get<{ data: CaseActivity[]; meta: Pagination }>(`/case/${id}/evidence-tsn`, { params });
		return response.data;
	},
};

export default caseEvidenceService;
